module.exports = __webpack_public_path__ + "img/snow_fall_00032.e82ec53e.png";